// extracted by mini-css-extract-plugin
export default {"icon":"svg_icon__dWseE","disabled":"svg_disabled__gzL-1"};